import Box from './Box';

export default function Icon({ children, ...props }) {
	return (
		<Box {...props} component="svg" name="icon" aria-hidden="true">
			{children}
		</Box>
	);
}
